// Analytics utility functions
export class Analytics {
  private static SESSION_KEY = 'datehack_session_id';
  private static VISITED_KEY = 'datehack_visited_pages';

  // Generate or get existing session ID
  private static getSessionId(): string {
    if (typeof window === 'undefined') return '';
    
    let sessionId = localStorage.getItem(this.SESSION_KEY);
    if (!sessionId) {
      sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
      localStorage.setItem(this.SESSION_KEY, sessionId);
    }
    return sessionId;
  }

  // Check if this is a unique visit to this page
  private static isUniqueVisit(pagePath: string): boolean {
    if (typeof window === 'undefined') return true;
    
    const visitedPages = JSON.parse(localStorage.getItem(this.VISITED_KEY) || '[]');
    const isUnique = !visitedPages.includes(pagePath);
    
    if (isUnique) {
      visitedPages.push(pagePath);
      localStorage.setItem(this.VISITED_KEY, JSON.stringify(visitedPages));
    }
    
    return isUnique;
  }

  // Track a page visit
  static async trackPageVisit(pagePath: string = '/'): Promise<void> {
    try {
      // Only track on client side
      if (typeof window === 'undefined') return;

      const sessionId = this.getSessionId();
      const isUniqueVisitor = this.isUniqueVisit(pagePath);
      const referrer = document.referrer;

      const response = await fetch('/api/analytics/track', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          page_path: pagePath,
          referrer: referrer,
          session_id: sessionId,
          is_unique_visitor: isUniqueVisitor,
        }),
      });

      if (!response.ok) {
        console.warn('Analytics tracking failed:', response.status);
      }
    } catch (error) {
      console.warn('Analytics tracking error:', error);
    }
  }

  // Track page visit with automatic page detection
  static async trackCurrentPage(): Promise<void> {
    if (typeof window !== 'undefined') {
      await this.trackPageVisit(window.location.pathname);
    }
  }
} 